"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MleAndGhcValidationBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var MleAndGhcValidationBanner = /** @class */ (function (_super) {
    __extends(MleAndGhcValidationBanner, _super);
    function MleAndGhcValidationBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = function () {
            _this.setState({
                showBanner: false
            });
        };
        _this.state = {
            showBanner: true
        };
        return _this;
    }
    MleAndGhcValidationBanner.prototype.render = function () {
        var validationMessage = this.getSetting("validationMessage", undefined);
        if (!validationMessage || !this.state.showBanner) {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, {}));
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "page-validation journey-validation-summary", role: "alert", children: [(0, jsx_runtime_1.jsx)("div", { className: "page-validation-alert", children: (0, jsx_runtime_1.jsx)("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-red.svg") }) }), (0, jsx_runtime_1.jsxs)("div", { className: "page-validation-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-top", children: "Oops! Something went wrong." }), (0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-bottom", children: validationMessage })] }), (0, jsx_runtime_1.jsx)("div", { className: "page-validation-close", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn page-validation-close-button", "aria-label": "close alert", onClick: this.handleClose }) })] }));
    };
    return MleAndGhcValidationBanner;
}(plugin_journey_1.WidgetBase));
exports.MleAndGhcValidationBanner = MleAndGhcValidationBanner;
//# sourceMappingURL=MleAndGhcValidationBanner.js.map